import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntitatiComponent } from './entitati.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ViewEntitateComponent } from './view-entitate/view-entitate.component';
 

@NgModule({
  declarations: [EntitatiComponent, ViewEntitateComponent],
  imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
  exports: [EntitatiComponent, ViewEntitateComponent],
})
export class EntitatiModule {}
